var _defs, _style, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39",
    width: 39,
    height: 39,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "member") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 32,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAgCAMAAABJuvqBAAAAAXNSR0IB2cksfwAAARRQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////qovlLgAAAFx0Uk5TAAIVKDM7NzAfCgUsWHiAf2pEFgY+dV4pclMDSh1beydcfSRNXTFJZzp+BAh0Xz92CQx5cw5gejQjfDJFQmEcAUM4DWhxBxRAdy9mE24Pbys9WRA2Um1sLmMmGVCUIUU3AAABhklEQVR4nHWS6ULCMBCEl0uwwJZLQBQURDmKIqAgohbxBhVE8Xz/9zClIdlCO386O/mSbLcFsMjl9nh9a/7AOjhLCYbCaEqNRGP2UDyxgRYlAzZUKo0r2ly+O7O1CjGlt61dZW0pxNwOPWvXgULMFyS2J2O16AvuH5A+c+4FFZRhyRxDplwRUaRqUlpNRIfxxdZCXoRHZhIVQf1YNuKT1zbmhzVF4KOv1RJx1Ki9srMTOiQ5yZqLlaeibFtm2ZHbz9hku6JqWbBzifUAArKqVCl2IRcuLZuwQLFLmdcAEgRLEuqK5KiTqTF1BKVFaK5Bn5bqNacGNzTGOJk24i3rNnUHcP8Qxsc2eTf63ZtPejnHnmFjRMPRICRWngFiwo/YZS+9V2a7xbEOoE9UvvTGijqnGrwtZTp1cfvOsTLzH3PXHoGN+Hc1/szC0iiolJmxVjKs/slcxGWLgcfA/HP7JdyqdHbcLGPab8wpDhhMEH+4HbWzThT84p/w474jlhmSizRHjC/9A7dBOeE8oadGAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.3d29d1f9.svg";
export { ForwardRef as ReactComponent };